import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=0ba60658&"
var script = {}
import style0 from "./loader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0ba60658', component.options)
    } else {
      api.reload('0ba60658', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=0ba60658&", function () {
      api.rerender('0ba60658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ui/loader.vue"
export default component.exports